export const DEFAULT_ELECTRICITY_PRICE_PER_UNIT = 10
export const DEFAULT_GAS_PRICE_PER_UNIT = 15

export function calculateUtilityAmount(
	previousReading: number,
	currentReading: number,
	pricePerUnit: number,
): number {
	return (currentReading - previousReading) * pricePerUnit
}

export function derivePricePerUnit(
	previousReading: number,
	currentReading: number,
	amount: number,
	defaultRate: number,
): number {
	const units = currentReading - previousReading
	return units > 0 ? amount / units : defaultRate
}
